import React from "react";
import Gradient from "./Gradient";
import MobileHeader from "./MobileHeader";

const Header = ({ data, current, onLanguageChange }) => {
  if (!data) return null;

  const { logo, btnText, navigation } = data;

  const logoUrl = logo?.url ? logo.url : "";

  const handleNavItemClick = (url) => {
    const target = document.querySelector(url);
    console.log(target);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="header">
      <Gradient imageName="gradient1" className="gradientLeft" top="0px" left="0px" />
      <div className="flex-wrapper">
        <div className="flex-container">
          <div className="header-wrapper">
            <a className="logo" href="/">
              <img src={logoUrl} alt="Domm Digital" />
            </a>

            <nav aria-label="Main navigation">
              <ul className="navigation desktop-nav">
                {navigation?.map((item) => (
                  <li key={item.id} className="hover-underline-animation">
                    <button onClick={() => handleNavItemClick(item.url)}>
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="right-content">
              <button
                className="transparent-button desktop-btn"
                onClick={() => handleNavItemClick("#contacts")}
              >
                <span>{btnText}</span>
              </button>
              <div className="switch-lang">
                <span
                  onClick={() => onLanguageChange("uk")}
                  className={current === "uk" ? "active" : "disabled"}
                >
                  Укр
                </span>
                <span className="splitter"></span>
                <span
                  onClick={() => onLanguageChange("ru")}
                  className={current === "ru" ? "active" : "disabled"}
                >
                  Рус
                </span>
                {/* <span className="splitter"></span>
                <span
                  onClick={() => onLanguageChange("en")}
                  className={current === "en" ? "active" : "disabled"}
                >
                  Eng
                </span> */}
              </div>
            </div>
          </div>

          <MobileHeader
            data={data}
            current={current}
            onLanguageChange={onLanguageChange}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
